<template>
  <div id="LandingVideo">
    <div class="videoWrapper">
      <vueVimeoPlayer
        ref="landingPlayer"
        class="landingPlayer"
        :video-id="video"
        :options="options"
      ></vueVimeoPlayer>
    </div>
    <div class="sound" :class="{ active: sound}" @click="muteControl(), sound = false">
      <img src="@/assets/icons/icon_sound.svg" />
    </div>
    <div class="overlay" />
    <div class="controls">
      <!-- <div class="volume" @click="muteControl()">
        <img src="@/assets/icons/volume-on.svg" />
      </div> -->
      <router-link
        class="controls-link"
        :to="{ name: `Home`, params: $route.params }"
        >SKIP VIDEO</router-link
      >
    </div>
  </div>
</template>

<script>
  import { vueVimeoPlayer } from "vue-vimeo-player";

  export default {
    name: "LandingVideo",
    components: {
      vueVimeoPlayer
    },
    data() {
      return {
        video: "1052353064",
        options: {
          background: true,
          autoplay: true,
          loop: true,
          responsive: true,
          muted: true,
          // controls: false
        },
        muted: true,
        sound: true
      };
    },
    methods: {
      muteControl() {
        const vid = document.getElementById("LandingVideo");

        if (this.muted) {
          this.$refs.landingPlayer.unmute();
          this.muted = false;
          // vid.unMute()
        } else {
          this.$refs.landingPlayer.mute();
          this.muted = true;
          // vid.mute();
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  #LandingVideo {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    .sound {
      position: absolute;
      z-index: 3;
      top: 50%;
      left: 50%;
      opacity: 0;
      transform: translate(-50%, -50%);
      cursor: pointer;
      max-height: 0;
      overflow: hidden;
      transition: all 0.3s ease-in-out;
      &.active {
        opacity: 1;
        max-height: 500px;
        transition: all 0.3s ease-in-out;
      }
    }
    .controls {
      z-index: 3;
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: center;
      top: 40px;
      right: 40px;
      .volume {
        cursor: pointer;
      }
      &-link {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        text-decoration: none;
        font-size: 13px;
        @include nexaBold;
        line-height: 18px;
        text-align: center;
        text-transform: uppercase;
        min-width: calc(178px * 1.25);
        height: calc(33px * 1.25);
        background: url("~@/assets/bg/white-btn-bg.png") scroll no-repeat center center;
        background-size: calc(178px * 1.25) calc(33px * 1.25);
        font-size: calc(13px * 1.25);
        color: #FF4B00;
      }
    }
  }
</style>

<style lang="scss">
  #LandingVideo {
    .videoWrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      overflow: hidden;
      .landingPlayer {
        height: 100%;
        width: 100%;
        div {
          position: relative;
          height: 100%;
          width: 100%;
          padding: 0 !important;
        }
      }
      iframe {
        width: 100vw;
        height: 56.25vw;
        min-height: 100vh;
        min-width: 177.77vh;
        @media (min-width: 1500px) {
          min-height: 115vh;
          min-width: 200vh;
          transform: translateY(-10%);
        }
        @media (max-width: 1300px) {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-25%, 0);
        }
        @media (max-width: 850px) {
          transform: translateX(-50%);
        }
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
      }
    }
  }
</style>